export const MarketingClientConstants = {
    placeholderClass: "mcBan",
    rootElement: "body",
    allowHarmonyTestingUrlParam: "enableHarmonyTest",
    allowHarmonyPreProductionUrlParam: "enableHarmonyPreProd",
    referrerParam: "referrer",
    refererParam: "referer",
    overwriteProfileUrlParam: "profileToOverwrite",
    dmParametersGlobalKey: "domain_marketing_params",
    dmBehavioralProfilesKey: "marketingDomainRequestParams",
    encodeHarmonyProfileHelperKey: "encodeHarmonyProfile",
    decodeHarmonyProfileHelperKey: "decodeHarmonyProfile",
    placeholderDataSetAttribute: "data-mc-placeholder-id",
    ddboxTemplateId: "17632443",
    plywakTemplateId: "17632437",
    hiddenClassName: "hidden", // @TODO - sprawdzić czy nie powinien być tylko d-hidden1`
    disabledClassName: "disabled",
    dHiddenClassName: "d-hidden",
    hasErrorClassName: "has-error"
};
